import type { ArticleCard as ArticleCardType } from 'types/capi/shared';

import ArticleCard from '~/components/ArticleCard';
import Metadata from '~/components/ArticleCard/Metadata';
import Tracked from '~/components/Tracked';

const PAGE_POSITION = 'Homepage Latest Feature';

type Props = { article: ArticleCardType };

export default function Feature({ article }: Props) {
  return (
    <div className="w-full bg-black">
      <div className="mx-auto max-w-desktop px-4 py-10 md:px-0 md:py-20">
        <div className="hidden md:flex md:flex-row md:items-center md:gap-10">
          <Tracked.InternalLink
            to={article.link.path}
            variant="none"
            pagePosition={PAGE_POSITION}
            name="LATEST_NEWS"
            className="flex w-full flex-1 flex-col gap-4 text-start"
          >
            <Metadata item={article} size="lg" theme="dark" expanded />
          </Tracked.InternalLink>
          <div>
            <ArticleCard
              className="block size-full h-[570px] w-[456px]"
              item={article}
              name="LATEST_NEWS"
              pagePosition={PAGE_POSITION}
              variant="4/5-text-over"
            />
          </div>
        </div>
        <ArticleCard
          className="md:hidden"
          options={{ expandedMetadata: true, theme: 'dark', titleSize: 'md' }}
          item={article}
          name="LATEST_NEWS"
          pagePosition={PAGE_POSITION}
          variant="16/9-text-under"
        />
      </div>
    </div>
  );
}
